import { Component, OnInit } from '@angular/core';
import {
	FormBuilder,
	FormControl,
	FormGroup,
	Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService, FormService } from 'src/app/services';

@Component({
	selector: 'app-signup',
	templateUrl: './signup.component.html',
	styleUrls: ['./signup.component.css'],
})
export class SignupComponent implements OnInit {
	public signUpForm = new FormGroup({
		name: new FormControl('', Validators.required),
		email: new FormControl('', [Validators.required, Validators.email]),
		password: new FormControl('', Validators.required),
		subscribeNewsLetter: new FormControl('false'),
		agreeTerms: new FormControl('false'),
		agreePolicy: new FormControl('false'),
	});

	isLoading = false;

	signUpFormErrorMessages = {
		email: [
			{ type: 'required', message: 'Email is required' },
			{ type: 'email', message: 'Enter a valid email' },
		],
		name: [{ type: 'required', message: 'Name is required' }],
		password: [{ type: 'required', message: 'Password is required' }],
	};

	constructor(
		private router: Router,
		public authService: AuthService,
		public form: FormBuilder,
		public formService: FormService,
	) {}

	public ngOnInit(): void {}

	public signupUsingGoogle(subscribeToNl: any) {
		this.authService.googleSignUp(subscribeToNl.checked);
	}

	public onSubmit(signUpForm: any) {
		if (!this.isLoading) {
			this.isLoading = true;

			this.formService.markFormGroupTouched(signUpForm);
			if (signUpForm.invalid) {
				this.isLoading = false;
				this.authService.addToastMsg('Please fill missing details.');
			} else {
				const { agreePolicy, agreeTerms } = signUpForm.value;

				if (agreePolicy === 'false' || agreeTerms === 'false') {
					this.isLoading = false;
					this.authService.addToastMsg('Please select privacy & Terms.');
				} else {
					this.isLoading = true;
					const {
						name,
						email,
						password,
						subscribeNewsLetter,
					} = signUpForm.value;

					this.authService
						.signUp(name, email, password, subscribeNewsLetter)
						.catch(e => (this.isLoading = false));
				}
			}
		}
	}
}
